// TODO: Remove this file. Use @granular/fabric-catalog instead.

import axios, { AxiosResponse } from "axios";
import { AuthSuccessSpec } from "../models/authentication";

/**
 * Exchange a refresh token for fresh ID, Access, and Refresh Tokens
 *
 * @param token Refresh token
 * @returns An `AuthSuccessSpec` object
 */
const refreshToken = async (token: string): Promise<AuthSuccessSpec> =>
  (
    await axios.post<{ token: string }, AxiosResponse<AuthSuccessSpec>>(
      "/api/auth-svc/refresh_legacy",
      {
        token,
      },
    )
  ).data;

/**
 * Exchange a session code for ID, Access, and Refresh Tokens
 *
 * @param code Session code
 * @returns An `AuthSuccessSpec` object
 */
const fetchTokens = async (code: string): Promise<AuthSuccessSpec> =>
  (await axios.get(`/api/auth-svc/issue-token?code=${code}`)).data;

export default {
  refreshToken,
  fetchTokens,
};
